import gsap from "gsap";
import Swiper, { Autoplay, EffectCreative } from "swiper";

document.addEventListener("DOMContentLoaded", () => {
  const tunings = document.querySelectorAll(".tuning");
  let tuningCarbon;
  let tuningGloss;

  if (tunings) {
    tunings.forEach((tuning) => {
      let firstTuningSteps = null
      let firstTuningStepsItems = null
      if (!tuning) return;
      if (tuning.classList.contains("tuning--carbon")) {
        tuningCarbon = tuning;
        firstTuningSteps = tuningCarbon?.querySelector('.tuning-steps')
        firstTuningStepsItems = Array.from(firstTuningSteps?.querySelectorAll('.tuning-steps__item')).slice().reverse()
      }
      if (tuning.classList.contains("tuning--gloss")) {
        tuningGloss = tuning;
        if (tunings.length === 1) {
          tuning.classList.add("tuning--gloss-alone");
        }
      }
      const tuningStep = tuning.querySelectorAll(".tuning-steps");
      const tuningSteps = tuning.querySelectorAll(".tuning-steps__item");
      const tuningTitle = tuning.querySelector(".tuning__title");
      const tuningPoints = tuning.querySelectorAll(".tuning-points__item");
      const tuningContainer = tuning.querySelector(".tuning__container--front");
      const tuningNames = tuning.querySelectorAll(".tuning-points__name");
      const tuningAccordions = tuning.querySelectorAll(".tuning-cart .accordion");
      const tuningPopups = tuning.querySelectorAll(".tuning-popup");
      const tuningButton = tuning.querySelector(".tuning-buttons__position .tuning-buttons__input");
      const timeLine = gsap.timeline();
      const timeLine2 = gsap.timeline();
      let duration = 0.75;
      const delay = 0;
      let animate = false;

      const startAnimate = (container = tuningContainer) => {
        if (animate) return;
        animate = true;
        tuningSteps.forEach((item) => {
          if(item.parentNode !== firstTuningSteps){
            timeLine.to(item, { opacity: 1, delay, duration, ease: "none" });
          }
        });
        if(tuning == tuningCarbon){
          firstTuningStepsItems.forEach((item) => {
            timeLine2.to(item, { opacity: 1, delay, duration, ease: "none" });
          });
        }

        gsap.to(tuningTitle, { duration, delay: duration * 2, opacity: 1, ease: "none" });
        tuningPoints.forEach((item, index) => {
          gsap.to(item, { duration, delay: duration * 3, opacity: 1, ease: "none" });
          const line = item.querySelector(".tuning-points__line-list");
          const lineLeft = (findClass = null) => {
            line.classList.add("tuning-points__line-list--left");
            if (findClass) {
              line.closest(".tuning-points__item")?.classList.add("tuning-points__item--left");
            }
            if (item.offsetLeft > container.clientWidth / 2) {
              line.closest(".tuning-points__item")?.classList.add("tuning-points__item--left-right");
            }
            gsap.to(line, { right: 0, duration: 0, delay });
            gsap.fromTo(line, { width: 0 }, { width: `${item.offsetLeft - 10}px`, duration, delay: duration * 3 });
          };
          const lineRight = (findClass = null) => {
            line.classList.add("tuning-points__line-list--right");
            if (findClass) {
              line.closest(".tuning-points__item")?.classList.add("tuning-points__item--right");
            }
            if (item.offsetLeft <= container.clientWidth / 2) {
              line.closest(".tuning-points__item")?.classList.add("tuning-points__item--right-left");
            }
            gsap.to(line, { left: 0, duration: 0, delay });
            gsap.fromTo(
              line,
              { width: 0 },
              {
                width: `${container.clientWidth - item.offsetLeft - 60}px`,
                duration,
                delay: duration * 3,
              }
            );
          };
          const viewName = () => {
            gsap.to(tuningNames[index], { width: 0, duration: 0, delay });
            gsap.to(tuningNames[index], { width: "auto", duration, delay: duration * 4 });
          };

          if (line.classList.contains("tuning-points__line-list--left")) {
            lineLeft(true);
            viewName();
          } else if (line.classList.contains("tuning-points__line-list--right")) {
            lineRight(true);
            viewName();
          } else {
            item.offsetLeft <= container.clientWidth / 2 ? lineLeft() : lineRight();
            viewName();
          }
        });
      };

      if (tuningPoints) {
        const array = Object.values(tuningPoints).sort((a, b) => {
          const aTop = a.style.getPropertyValue("--top");
          const bTop = b.style.getPropertyValue("--top");
          if (aTop > bTop) {
            return 1;
          }

          if (aTop < bTop) {
            return -1;
          }
          return 0;
        });
        array.forEach((item, index) => {
          item.style.zIndex = index + 10;
        });
      }

      if (tuningStep) {
        const resize = () => {
          tuningStep.forEach((step) => {
            step.style.height = `${tuningSteps[0].clientHeight}px`;
          });
        };
        window.addEventListener("load", () => {
          resize();
        });
        window.addEventListener("resize", resize);
      }

      if (tuningButton) {
        let timeLine = gsap.timeline();
        let timeLine2 = gsap.timeline();
        const tuningBack = tuning.querySelector(".tuning__container--back");
        const accordionsBack = tuning.querySelector(".tuning-cart--back");
        const tuningFront = tuning.querySelector(".tuning__container--front");
        const accordionsFront = tuning.querySelector(".tuning-cart--front");
        let activeIndex = 0;

        const deleteAccordion = () => {
          if (window.innerWidth > 1024) {
            accordionsBack.removeAttribute("style");
            accordionsFront.removeAttribute("style");
          }
        };

        window.addEventListener("resize", deleteAccordion);

        tuningButton.addEventListener("check", () => {
          if (tuningButton.checked) {
            timeLine.to(tuningFront, { duration: 0.3, opacity: 0, delay: 0 });
            timeLine.to(tuningBack, { duration: 0.3, delay: 0, opacity: 1 });
            if (window.innerWidth <= 1024) {
              timeLine2.to(accordionsFront, { duration: 0.3, opacity: 0, delay: 0 });
              timeLine2.to(accordionsFront, { duration: 0, display: "none", delay: 0 });
              timeLine2.to(accordionsBack, { duration: 0, display: "block", delay: 0 }, ">");
              timeLine2.to(accordionsBack, { duration: 0.3, delay: 0, opacity: 1 });
              const open = accordionsBack.querySelector(".accordion--open .accordion__head");
              if (open) {
                open.dispatchEvent(new Event("click"));
              }
            }
            return;
          }
          timeLine.to(tuningBack, { duration: 0.3, opacity: 0, delay: 0 });
          timeLine.to(tuningFront, { duration: 0.3, delay: 0, opacity: 1 });
          if (window.innerWidth <= 1024) {
            timeLine2.to(accordionsBack, { duration: 0.3, opacity: 0, delay: 0 });
            timeLine2.to(accordionsBack, { duration: 0, display: "none", delay: 0 });
            timeLine2.to(accordionsFront, { duration: 0, display: "block", delay: 0 }, ">");
            timeLine2.to(accordionsFront, { duration: 0.3, delay: 0, opacity: 1 });
            const open = accordionsFront.querySelector(".accordion--open .accordion__head");
            if (open) {
              open.dispatchEvent(new Event("click"));
            }
          }
        });

        const resize = () => {
          if (window.innerWidth > 1024) {
            gsap.to(accordionsBack, { duration: 0, display: "none", delay: 0, opacity: 0 });
            gsap.to(accordionsFront, { duration: 0, display: "none", delay: 0, opacity: 0 });
          }
        };
        window.addEventListener("load", resize);
        window.addEventListener("resize", resize);
      }

      if (tuning && tuningSteps && tuningTitle && tuningPoints && tuningNames && tuningPopups) {
        let activate = null;

        const resiseItems = () => {
          tuningPoints.forEach((item, index) => {
            const line = item.querySelector(".tuning-points__line-list");
            const height = line.querySelector(".tuning-points__line");
            const name = line.querySelector(".tuning-points__name");
            if (name && height) {
              name.style.setProperty("bottom", `${line.classList.contains("tuning-points__line-list--down") ? "-" + height.clientHeight : height.clientHeight - 2}px`);
            }
            if (line.classList.contains("tuning-points__line-list--left")) {
              gsap.to(line, { "--width": `${item.offsetLeft - 10}px`, width: `${item.offsetLeft - 10}px`, duration: 0, delay });
            } else {
              gsap.to(line, {
                "--width": `${tuningContainer.clientWidth - item.offsetLeft - 60}px`,
                width: `${tuningContainer.clientWidth - item.offsetLeft - 60}px`,
                duration: 0,
                delay,
              });
            }
          });
        };

        window.addEventListener("resize", () => {
          resiseItems();
        });
        setTimeout(() => {
          const observer = new IntersectionObserver(
            (entries, observer) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  startAnimate();
                  setTimeout(() => {
                    resiseItems();
                  }, 2000);

                  observer.unobserve(entry.target);
                }
              });
            },
            { threshold: 0.5 }
          );

          observer.observe(tuning);
        }, 50);

        if (tuning.classList.contains("tuning--gloss") && tunings.length > 1) {
          duration = 0;
          startAnimate();
        } else {
          duration = 0.5;
        }

        let activeIndex = null;

        let swiper = null;
        let activePopup = null;

        const stopSlider = () => {
          if (swiper) {
            swiper.autoplay.stop();
            swiper.destroy();
            swiper = null;
          }
          activePopup?.classList.remove("tuning-popup--view");
          document.documentElement.style.overflow = "hidden auto";
          document.querySelector(".thumbs__item--active")?.classList.remove("thumbs__item--active");
          activeIndex = null;
          activePopup = null;
        };

        const startSlider = (index, accordion = null) => {
          activeIndex = index;
          let activePagination = 0;
          let closeButton;
          let slider;
          if (accordion) {
            slider = Object.values(tuningAccordions)
              .find((item) => item.getAttribute("data-popup") === index)
              ?.querySelector(".tuning-popup__slider");
          } else {
            activePopup = Object.values(tuningPopups).find((item) => item.getAttribute("data-popup") === index);
            activePopup?.classList.add("tuning-popup--view");
            document.documentElement.style.overflow = "hidden";
            closeButton = activePopup?.querySelector(".tuning-popup__close");
            slider = activePopup?.querySelector(".tuning-popup__slider");
          }
          if (slider) {
            const paginations = slider.querySelectorAll(".thumbs__item");
            const slides = slider.querySelectorAll(".tuning-popup__slide");
            let timeout;

            swiper = new Swiper(slider, {
              modules: [EffectCreative, Autoplay],
              effect: "creative",
              speed: 1000,
              parallax: true,
              spaceBetween: 2,
              loop: true,
              autoplay: {
                delay: 10000,
              },
              allowTouchMove: false,
              creativeEffect: {
                prev: {
                  translate: ["-20%", 0, -1],
                },
                next: {
                  translate: ["100%", 0, 0],
                },
              },
            });

            swiper.autoplay.stop();

            swiper.on("slideChange", () => {
              paginations[activePagination].classList.remove("thumbs__item--active");
              activePagination = swiper.realIndex;
              const video = slides[activePagination].querySelector("video");
              video?.pause();

              setTimeout(() => {
                paginations[activePagination].classList.add("thumbs__item--active");
                if (video) {
                  video.play();
                  video.currentTime = 0;
                }
              }, 1000);
            });

            const startAnimation = () => {
              clearTimeout(timeout);
              swiper.autoplay.stop();
              timeout = setTimeout(() => {
                swiper.slideNext();
                swiper.autoplay.start();
                clearTimeout();
              }, 30000);
            };

            paginations.forEach((pagination, index) => {
              pagination.addEventListener("click", () => {
                swiper.slideTo(index + 1);
                startAnimation();
              });
            });

            setTimeout(() => {
              paginations[activePagination].classList.add("thumbs__item--active");
              swiper.autoplay.start();
            });
          }
          if (closeButton) {
            closeButton.addEventListener("click", stopSlider);
          }
        };

        document.addEventListener("keydown", (e) => {
          if (e.key === "Escape" && activeIndex) stopSlider();
        });

        tuningNames.forEach((name, id) => {
          const index = name.getAttribute("data-popup");
          name.addEventListener("click", () => {
            startSlider(index);
          });
        });

        tuningAccordions.forEach((accordion) => {
          const index = accordion.getAttribute("data-popup");

          accordion.querySelector(".accordion__head")?.addEventListener("click", (e) => {
            if (activeIndex === index) {
              stopSlider();
              return;
            }
            if (activeIndex !== null) {
              Object.values(tuningAccordions)
                .find((item) => item.getAttribute("data-popup") === activeIndex)
                .querySelector(".accordion__head")
                ?.click();
              stopSlider();
            }
            startSlider(index, true);
          });
        });
      }

      const tuningModals = document.querySelectorAll(".tuning-modal");

      if (tuningModals) {
        const appleExpression = /Apple/i;
        const safariExpression = /Safari/i;
        const isAppleSafari = () => {
          return appleExpression.test(navigator.vendor) && safariExpression.test(navigator.userAgent);
        };

        let safari = isAppleSafari();

        if (safari) {
          tuningModals.forEach((item) => {
            item.classList.add("tuning-modal--safari");
          });
        }
      }
    });

    const tuningButtons = document.querySelectorAll(".tuning-buttons__position .tuning-buttons__input");
    const tuningMaterials = document.querySelectorAll(".tuning-buttons__material .tuning-buttons__input");
    const tuningImagesGloss = document.querySelectorAll(".tuning-image--gloss");
    const tuningImagesCarbon = document.querySelectorAll(".tuning-image--carbon");
    const beafList = document.querySelector(".beaf .beaf__list");
    const detailsListMaterials = document.querySelector(".details-list .tuning-buttons__input");
    const beafItemsMaterial1 = document.querySelectorAll(`.beaf-item[data-material=${detailsListMaterials?.dataset.unchecked}]`);
    const beafItemsMaterial2 = document.querySelectorAll(`.beaf-item[data-material=${detailsListMaterials?.dataset.checked}]`);

    if (tuningMaterials && tuningButtons) {
      const changeButton = (checked) => {
        tuningButtons.forEach((tuningButton) => {
          tuningButton.checked = checked;
        });
        tuningButtons.forEach((tuningButton) => tuningButton.dispatchEvent(new Event("check")));
      };

      tuningButtons.forEach((tuningButton) => {
        tuningButton.addEventListener("change", () => {
          changeButton(tuningButton.checked);
        });
        if (tuningButton.checked) {
          changeButton(true);
        }
      });
      changeButton(false);

      const changeMaterial = (checked) => {
        if (tuningGloss && tuningCarbon) {
          const timeLine = gsap.timeline();
          const delay = 0;
          const duration = 0.3;
          const tuningStepsCarbon = tuningCarbon.querySelector(".tuning-steps");
          const tuningStepsGloss = tuningGloss.querySelector(".tuning-steps");
          if (checked) {
            tuningStepsGloss.style.height = `${tuningStepsCarbon.clientHeight}px`;
            timeLine.to(tuningCarbon, { opacity: 0, delay, duration });
            timeLine.to(tuningCarbon, { display: "none", delay, duration: 0 });
            timeLine.to(tuningGloss, { display: "block", delay, duration: 0 }, ">");
            timeLine.to(tuningGloss, { opacity: 1, delay, duration });
          } else {
            tuningStepsCarbon.style.height = `${tuningStepsGloss.clientHeight}px`;
            timeLine.to(tuningGloss, { opacity: 0, delay, duration });
            timeLine.to(tuningGloss, { display: "none", delay, duration: 0 });
            timeLine.to(tuningCarbon, { display: "block", delay, duration: 0 }, ">");
            timeLine.to(tuningCarbon, { opacity: 1, delay, duration });
          }

          setTimeout(() => {
            window.dispatchEvent(new Event("resize"));
            setTimeout(() => {
              window.dispatchEvent(new Event("resize"));
            });
          }, 310);

          tuningMaterials.forEach((tuningButton) => {
            tuningButton.checked = checked;
          });
          if (tuningImagesGloss && tuningImagesCarbon) {
            const changeMaterialImage = (material1, material2) => {
              setTimeout(() => {
                material1.forEach((image) => {
                  image.classList.add("tuning-image--view");
                });
                material2.forEach((image) => {
                  image.classList.remove("tuning-image--view");
                });
              }, 300);
            };

            if (checked) {
              changeMaterialImage(tuningImagesGloss, tuningImagesCarbon);
            } else {
              changeMaterialImage(tuningImagesCarbon, tuningImagesGloss);
            }
          }
        }
      };

      const changeBeafMaterial = (checked) => {
        const chosenColor = document.querySelector(".color-picker__item.active")?.dataset.color;
        if (chosenColor) {
          const timeLine = gsap.timeline();
          let itemsToShow = null;
          if (!checked) {
            itemsToShow = Array.from(beafItemsMaterial1).filter((el) => el.dataset.color == chosenColor);
          } else {
            itemsToShow = Array.from(beafItemsMaterial2).filter((el) => el.dataset.color == chosenColor);
          }
          if (beafItemsMaterial1 && beafItemsMaterial2) {
            beafList.style.height = window.getComputedStyle(beafList).height;
            timeLine.to([...beafItemsMaterial1, ...beafItemsMaterial2], { duration: 0.3, autoAlpha: 0, display: "none" });
            timeLine.to(itemsToShow, {
              duration: 0.3,
              autoAlpha: 1,
              display: "block",
              onComplete: () => {
                beafList.style.height = "unset";
              },
            });
          }
        }
      };

      tuningMaterials.forEach((tuningButton) => {
        tuningButton.addEventListener("change", () => {
          changeMaterial(tuningButton.checked);
          changeBeafMaterial(tuningButton.checked);
        });
      });
      changeMaterial();
      changeBeafMaterial();
    }
  }

  if (tuningGloss && !tuningCarbon) {
    const tuningImagesGloss = document.querySelectorAll(".tuning-image--gloss");
    if (tuningImagesGloss) {
      tuningImagesGloss.forEach((image) => {
        image.classList.add("tuning-image--view");
      });
    }
  }

  if (!tuningGloss && tuningCarbon) {
    const tuningImagesCarbon = document.querySelectorAll(".tuning-image--carbon");
    if (tuningImagesCarbon) {
      tuningImagesCarbon.forEach((image) => {
        image.classList.add("tuning-image--view");
      });
    }
  }
});
